import { createApp } from 'vue'
import App    from './App.vue'
import router from './router'
// Global stylesheets — all under src/styles/, loaded in cascade order:
//   tokens (vars) → components (shared base classes) → app (live design system).
// app.css is last so the NVIDIA-green reskin wins, exactly as the old App.vue
// <style> block did. Component-specific styles stay scoped inside each .vue file.
import './styles/tokens.css'
import './styles/components.css'
import './styles/app.css'
import { applyLocale } from './composables/useI18n'
import { applyTheme }  from './composables/useTheme'

// Apply persisted language (dir/lang) + theme before mount to avoid a flash.
applyLocale()
applyTheme()

createApp(App).use(router).mount('#app')
